import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword } from '../features/auth/authSlice';
import { Link, useNavigate } from 'react-router-dom';

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { resetPasswordStatus, resetPasswordError } = useSelector(state => state.auth);

  useEffect(() => {
    // Get token from URL query param
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get('token');
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
    }
  }, []);

  useEffect(() => {
    // Redirect to login after successful reset
    if (resetPasswordStatus === 'succeeded') {
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    }
  }, [resetPasswordStatus, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      alert('Passwords do not match');
      return;
    }
    if (newPassword.length < 6) {
      alert('Password must be at least 6 characters');
      return;
    }
    dispatch(resetPassword({ token, newPassword }));
  };

  return (
    <div className="row justify-content-center">
      <div className="col-md-5">
        <div className="card border-0 shadow-lg">
          <div className="card-body p-5">
            <div className="text-center mb-4">
              <div style={{ fontSize: '3.5rem' }}>🔐</div>
              <h2 className="mt-3">Reset Password</h2>
              <p className="text-muted">Enter your new password</p>
            </div>

            {resetPasswordStatus === 'succeeded' && (
              <div className="alert alert-success d-flex align-items-center" role="alert">
                <span className="me-2">✅</span>
                <div>Password has been reset successfully! Redirecting to login...</div>
              </div>
            )}

            {resetPasswordStatus === 'failed' && (
              <div className="alert alert-danger d-flex align-items-center" role="alert">
                <span className="me-2">⚠️</span>
                <div>{resetPasswordError}</div>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label fw-bold">🔑 New Password</label>
                <input
                  className="form-control form-control-lg"
                  type="password"
                  value={newPassword}
                  onChange={e => setNewPassword(e.target.value)}
                  disabled={resetPasswordStatus === 'loading' || resetPasswordStatus === 'succeeded'}
                  placeholder="Enter new password"
                  required
                  minLength={6}
                />
              </div>
              <div className="mb-4">
                <label className="form-label fw-bold">🔑 Confirm Password</label>
                <input
                  className="form-control form-control-lg"
                  type="password"
                  value={confirmPassword}
                  onChange={e => setConfirmPassword(e.target.value)}
                  disabled={resetPasswordStatus === 'loading' || resetPasswordStatus === 'succeeded'}
                  placeholder="Confirm new password"
                  required
                  minLength={6}
                />
              </div>
              <button
                className="btn btn-lg w-100 text-white fw-bold"
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                }}
                type="submit"
                disabled={resetPasswordStatus === 'loading' || resetPasswordStatus === 'succeeded'}
              >
                {resetPasswordStatus === 'loading' ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                    Resetting...
                  </>
                ) : (
                  <>Reset Password →</>
                )}
              </button>
            </form>

            <div className="mt-3 text-center">
              <Link to="/login">← Back to Login</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
